import { Outlet, Link } from 'react-router-dom';
import { Button, Layout } from 'antd';
import { ArrowLeftOutlined, RobotOutlined } from '@ant-design/icons';
import { AiAgentProvider } from '@/contexts/AiAgentContext';
import '@/styles/ai-workspace.css';

const { Header } = Layout;

/**
 * Full-bleed chrome-free shell for ERP AI Workspace routes.
 */
export default function AiWorkspaceShell() {
  return (
    <AiAgentProvider>
      <div className="ai-workspace-shell">
      <Header
        style={{
          height: 48,
          lineHeight: '48px',
          padding: '0 16px',
          background: 'var(--ai-surface, #fff)',
          borderBottom: '1px solid var(--ai-border, rgba(0,0,0,0.06))',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <Link to="/home">
          <Button type="text" icon={<ArrowLeftOutlined />} size="small">
            Back to ERP
          </Button>
        </Link>
        <RobotOutlined style={{ color: '#1677ff' }} />
        <span style={{ fontWeight: 600, fontSize: 15 }}>ERP AI Workspace</span>
        <Link to="/ai/udq" style={{ marginLeft: 8, fontSize: 13 }}>
          UDQ Builder
        </Link>
        <Link to="/ai/dashboard" style={{ fontSize: 13 }}>
          Dashboard
        </Link>
      </Header>
      <Outlet />
      </div>
    </AiAgentProvider>
  );
}
